import * as React from 'react';

interface Props {
  loadingText?: string;
}

export const AuthenticatingView: React.SFC<Props> = props => {
  return (
    <div className="authenticating-spinner">
      <div className="text-center">
        <div className="mb-2">{'Authenticating. Just a moment.'}</div>
        <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
      </div>
    </div>
  );
};
